<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="namespaces">
					<app-heading :title="`${parent.name} Namespaces`">
						<template v-slot:left>
							<app-button v-if="$ravello.can('website.post')"
								class="d-none d-sm-inline-flex"
								color="success"
								outlined
								small
								:to="{ name: namespaceRoute, params: { namespace: 'new' } }"
							>Add Namespace</app-button>
						</template>
						<template v-slot:right>
							<app-button
								v-if="$ravello.can('website.post')"
								color="secondary"
								outlined
								small
								icon="fa-file-download"
								@click="onExport"
							>
									Export
							</app-button>
							<input-file
								type="json"
								button
								outlined
								small
								label="Import"
								@load="onImport"
							/>
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="namespaces"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								@update="fetchNamespaces"
							>
								<template v-slot:actions="{ item }">
									<app-button
										v-if="$ravello.can('website.put')"
										color="secondary"
										:to="{ name: namespaceRoute, params: { namespace: item._id } }"
										icon="fa-pencil-alt"
										:disabled="item.generated"
										table
									>
										Edit
									</app-button>
									<app-button-confirm
										v-if="$ravello.can('website.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove namespace <b>${item.name}</b>?`"
										title="Remove Namespace"
										:disabled="item.generated"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
					<app-floating-button
						class="d-inline-flex d-sm-none"
						:to="{ name: namespaceRoute, params: { namespace: 'new' } }"
						color="success"
						icon="fa-plus"
					/>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import websiteItemParentMixin from '@/mixins/websiteitemparent'
import { websiteContentTabs, websiteTemplateContentTabs } from '@/datasources/tabs'
import { importCollection, exportCollection } from '@/utils/import'

export default {
	mixins: [websiteItemParentMixin],
	data() {
		return {
			parent: {
				name: '',
				slug: '',
			},
			namespaces: [],
			count: -1,
			refresh: false,
			tabs: [],
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	computed: {
		namespaceRoute() {
			return this.isTemplate ? 'website-template-namespace' : 'website-namespace'
		},
	},
	async mounted() {
		this.parent = await this.$ravello.graphql(this.parentNode, this.parentId)
			.fields(['name', 'slug'])
			.query()
		this.tabs = this.isTemplate
			? websiteTemplateContentTabs(this.parentId)
			: websiteContentTabs(this.parentId)
	},
	methods: {
		async fetchNamespaces(pagination) {
			const request = this.$ravello.graphql('namespaces')
				.parent(this.$ravello.graphql(this.parentNode, this.parentId))
				.fields(['_id', 'name', 'slug', 'generated'])
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.namespaces = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to(this.parentEndpoint)
					.to(this.parentId)
					.to('namespaces')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		importRequest() {
			return this.$ravello.request()
				.v(2)
				.to(this.parentEndpoint)
				.to(this.parentId)
				.to('namespaces')
		},

		async onExport() {
			this.$store.dispatch('app/startLoading')

			const request = this.importRequest().fields(['name', 'slug'])

			await exportCollection(`${this.parent.slug}_namespaces.json`, request, {
				count: this.count,
			})

			this.$store.dispatch('app/stopLoading')
		},

		async onImport(importData) {
			this.$store.dispatch('app/startLoading')

			await importCollection(importData, this.importRequest(), 'slug')
			this.refresh = 'hard'

			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
